// GET SIM CARD LIST
export const GET_SIM_CARD_BEGIN = 'GET_SIM_CARD_BEGIN';
export const GET_SIM_CARD_SUCCESS = 'GET_SIM_CARD_SUCCESS';
export const GET_SIM_CARD_FAILURE = 'GET_SIM_CARD_FAILURE';

// GET SIM CARD LIST
export const GET_SIM_CARD_LIST_BEGIN = 'GET_SIM_CARD_LIST_BEGIN';
export const GET_SIM_CARD_LIST_SUCCESS = 'GET_SIM_CARD_LIST_SUCCESS';
export const GET_SIM_CARD_LIST_FAILURE = 'GET_SIM_CARD_LIST_FAILURE';

// GET USER LIST
export const GET_DIALER_LIST_BEGIN = 'GET_DIALER_LIST_BEGIN';
export const GET_DIALER_LIST_SUCCESS = 'GET_DIALER_LIST_SUCCESS';
export const GET_DIALER_LIST_FAILURE = 'GET_DIALER_LIST_FAILURE';

// GET DEALER LIST
export const GET_USER_LIST_BEGIN = 'GET_USER_LIST_BEGIN';
export const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS';
export const GET_USER_LIST_FAILURE = 'GET_USER_LIST_FAILURE';

// GET USER
export const GET_USER_BEGIN = 'GET_USER_BEGIN';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_USER_FAILURE = 'GET_USER_FAILURE';

// DELETE USER
export const DELETE_USER_BEGIN = 'DELETE_USER_BEGIN';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'DELETE_USER_FAILURE';

// GET USER DETAIL
export const GET_USER_DATA_BEGIN = 'GET_USER_DATA_BEGIN';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'GET_USER_DATA_FAILURE';

// UPDATE USER
export const UPDATE_USER_DATA_BEGIN = 'UPDATE_USER_DATA_BEGIN';
export const UPDATE_USER_DATA_SUCCESS = 'UPDATE_USER_DATA_SUCCESS';
export const UPDATE_USER_DATA_FAILURE = 'UPDATE_USER_DATA_FAILURE';

// CREATE USER
export const CREATE_USER_BEGIN = 'CREATE_USER_BEGIN';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

// AUTH USER
export const LOGIN_BEGIN = 'LOGIN_BEGIN';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SET_TOKEN = 'SET_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const LOGOUT = 'LOGOUT';

//
export const ACTIVATION_BEGIN = 'ACTIVATION_BEGIN';
export const ACTIVATION_CLEAR = 'ACTIVATION_CLEAR';
export const ACTIVATION_FAILURE = 'ACTIVATION_FAILURE';
export const ACTIVATION_SUCCESS = 'ACTIVATION_SUCCESS';
export const PASSWORD_EMAIL_BEGIN = 'PASSWORD_EMAIL_BEGIN';
export const PASSWORD_EMAIL_CLEAR = 'PASSWORD_EMAIL_CLEAR';
export const PASSWORD_EMAIL_FAILURE = 'PASSWORD_EMAIL_FAILURE';
export const PASSWORD_EMAIL_SUCCESS = 'PASSWORD_EMAIL_SUCCESS';
export const PASSWORD_RESET_BEGIN = 'PASSWORD_RESET_BEGIN';
export const PASSWORD_RESET_CLEAR = 'PASSWORD_RESET_CLEAR';
export const PASSWORD_RESET_FAILURE = 'PASSWORD_RESET_FAILURE';
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS';
export const PASSWORD_CHANGE_BEGIN = 'PASSWORD_CHANGE_BEGIN';
export const PASSWORD_CHANGE_CLEAR = 'PASSWORD_CHANGE_CLEAR';
export const PASSWORD_CHANGE_FAILURE = 'PASSWORD_CHANGE_FAILURE';
export const PASSWORD_CHANGE_SUCCESS = 'PASSWORD_CHANGE_SUCCESS';

// GET TARIFF GROUP LIST
export const GET_TARIFF_GROUP_LIST_BEGIN = 'GET_TARIFF_GROUP_LIST_BEGIN';
export const GET_TARIFF_GROUP_LIST_SUCCESS = 'GET_TARIFF_GROUP_LIST_SUCCESS';
export const GET_TARIFF_GROUP_LIST_FAILURE = 'GET_TARIFF_GROUP_LIST_FAILURE';

// CREATE TARIFF GROUP
export const CREATE_TARIFF_GROUP_BEGIN = 'CREATE_TARIFF_GROUP_BEGIN';
export const CREATE_TARIFF_GROUP_SUCCESS = 'CREATE_TARIFF_GROUP_SUCCESS';
export const CREATE_TARIFF_GROUP_FAILURE = 'CREATE_TARIFF_GROUP_FAILURE';

// UPDATE TARIFF GROUP
export const UPDATE_TARIFF_GROUP_BEGIN = 'UPDATE_TARIFF_GROUP_BEGIN';
export const UPDATE_TARIFF_GROUP_SUCCESS = 'UPDATE_TARIFF_GROUP_SUCCESS';
export const UPDATE_TARIFF_GROUP_FAILURE = 'UPDATE_TARIFF_GROUP_FAILURE';

// DELETE TARIFF GROUP
export const DELETE_TARIFF_GROUP_BEGIN = 'DELETE_TARIFF_GROUP_BEGIN';
export const DELETE_TARIFF_GROUP_SUCCESS = 'DELETE_TARIFF_GROUP_SUCCESS';
export const DELETE_TARIFF_GROUP_FAILURE = 'DELETE_TARIFF_GROUP_FAILURE';

// GET TARIFF LIST
export const GET_TARIFF_LIST_BEGIN = 'GET_TARIFF_LIST_BEGIN';
export const GET_TARIFF_LIST_SUCCESS = 'GET_TARIFF_LIST_SUCCESS';
export const GET_TARIFF_LIST_FAILURE = 'GET_TARIFF_LIST_FAILURE';

// CREATE TARIFF
export const CREATE_TARIFF_BEGIN = 'CREATE_TARIFF_BEGIN';
export const CREATE_TARIFF_SUCCESS = 'CREATE_TARIFF_SUCCESS';
export const CREATE_TARIFF_FAILURE = 'CREATE_TARIFF_FAILURE';

// UPDATE TARIFF
export const UPDATE_TARIFF_BEGIN = 'UPDATE_TARIFF_BEGIN';
export const UPDATE_TARIFF_SUCCESS = 'UPDATE_TARIFF_SUCCESS';
export const UPDATE_TARIFF_FAILURE = 'UPDATE_TARIFF_FAILURE';

// DELETE TARIFF
export const DELETE_TARIFF_BEGIN = 'DELETE_TARIFF_BEGIN';
export const DELETE_TARIFF_SUCCESS = 'DELETE_TARIFF_SUCCESS';
export const DELETE_TARIFF_FAILURE = 'DELETE_TARIFF_FAILURE';

// GET STATISTIC
export const GET_STATISTIC_BEGIN = 'GET_STATISTIC_BEGIN';
export const GET_STATISTIC_SUCCESS = 'GET_STATISTIC_SUCCESS';
export const GET_STATISTIC_FAILURE = 'GET_STATISTIC_FAILURE';

// GET PROVIDER LIST
export const GET_PROVIDER_LIST_BEGIN = 'GET_PROVIDER_LIST_BEGIN';
export const GET_PROVIDER_LIST_SUCCESS = 'GET_PROVIDER_LIST_SUCCESS';
export const GET_PROVIDER_LIST_FAILURE = 'GET_PROVIDER_LIST_FAILURE';

// GET PROVIDER AGENT LIST
export const GET_PROVIDER_AGENT_LIST_BEGIN = 'GET_PROVIDER_AGENT_LIST_BEGIN';
export const GET_PROVIDER_AGENT_LIST_SUCCESS = 'GET_PROVIDER_AGENT_LIST_SUCCESS';
export const GET_PROVIDER_AGENT_LIST_FAILURE = 'GET_PROVIDER_AGENT_LIST_FAILURE';

// GET SUBSCRIPTION LIST
export const GET_SUBSCRIPTION_LIST_BEGIN = 'GET_SUBSCRIPTION_LIST_BEGIN';
export const GET_SUBSCRIPTION_LIST_SUCCESS = 'GET_SUBSCRIPTION_LIST_SUCCESS';
export const GET_SUBSCRIPTION_LIST_FAILURE = 'GET_SUBSCRIPTION_LIST_FAILURE';

// CREATE SUBSCRIPTION
export const CREATE_SUBSCRIPTION_BEGIN = 'CREATE_SUBSCRIPTION_BEGIN';
export const CREATE_SUBSCRIPTION_SUCCESS = 'CREATE_SUBSCRIPTION_SUCCESS';
export const CREATE_SUBSCRIPTION_FAILURE = 'CREATE_SUBSCRIPTION_FAILURE';

// UPDATE SUBSCRIPTION
export const UPDATE_SUBSCRIPTION_BEGIN = 'UPDATE_SUBSCRIPTION_BEGIN';
export const UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
export const UPDATE_SUBSCRIPTION_FAILURE = 'UPDATE_SUBSCRIPTION_FAILURE';

// DELETE SUBSCRIPTION
export const DELETE_SUBSCRIPTION_BEGIN = 'DELETE_SUBSCRIPTION_BEGIN';
export const DELETE_SUBSCRIPTION_SUCCESS = 'DELETE_SUBSCRIPTION_SUCCESS';
export const DELETE_SUBSCRIPTION_FAILURE = 'DELETE_SUBSCRIPTION_FAILURE';

// GET PAYMENTS
export const GET_PAYMENTS_BEGIN = 'GET_PAYMENTS_BEGIN';
export const GET_PAYMENTS_SUCCESS = 'GET_PAYMENTS_SUCCESS';
export const GET_PAYMENTS_FAILURE = 'GET_PAYMENTS_FAILURE';

// GET PROVIDER PAYMENT LIST
export const GET_PROVIDER_PAYMENT_LIST_BEGIN = 'GET_PROVIDER_PAYMENT_LIST_BEGIN';
export const GET_PROVIDER_PAYMENT_LIST_SUCCESS = 'GET_PROVIDER_PAYMENT_LIST_SUCCESS';
export const GET_PROVIDER_PAYMENT_LIST_FAILURE = 'GET_PROVIDER_PAYMENT_LIST_FAILURE';

// GET REFUND PAYMENT LIST
export const GET_REFUND_PAYMENT_LIST_BEGIN = 'GET_REFUND_PAYMENT_LIST_BEGIN';
export const GET_REFUND_PAYMENT_LIST_SUCCESS = 'GET_REFUND_PAYMENT_LIST_SUCCESS';
export const GET_REFUND_PAYMENT_LIST_FAILURE = 'GET_REFUND_PAYMENT_LIST_FAILURE';

// GET DEALER PAYMENT LIST
export const GET_DEALER_PAYMENT_LIST_BEGIN = 'GET_DEALER_PAYMENT_LIST_BEGIN';
export const GET_DEALER_PAYMENT_LIST_SUCCESS = 'GET_DEALER_PAYMENT_LIST_SUCCESS';
export const GET_DEALER_PAYMENT_LIST_FAILURE = 'GET_DEALER_PAYMENT_LIST_FAILURE';

// CREATE DEALER PAYMENT LIST
export const CREATE_DEALER_PAYMENT_BEGIN = 'CREATE_DEALER_PAYMENT_BEGIN';
export const CREATE_DEALER_PAYMENT_SUCCESS = 'CREATE_DEALER_PAYMENT_SUCCESS';
export const CREATE_DEALER_PAYMENT_FAILURE = 'CREATE_DEALER_PAYMENT_FAILURE';

// UPDATE DEALER PAYMENT
export const UPDATE_DEALER_PAYMENT_BEGIN = 'UPDATE_DEALER_PAYMENT_BEGIN';
export const UPDATE_DEALER_PAYMENT_SUCCESS = 'UPDATE_DEALER_PAYMENT_SUCCESS';
export const UPDATE_DEALER_PAYMENT_FAILURE = 'UPDATE_DEALER_PAYMENT_FAILURE';

// GET SUBSCRIPTION PAYMENT LIST
export const GET_SUBSCRIPTION_PAYMENT_LIST_BEGIN = 'GET_SUBSCRIPTION_PAYMENT_LIST_BEGIN';
export const GET_SUBSCRIPTION_PAYMENT_LIST_SUCCESS = 'GET_SUBSCRIPTION_PAYMENT_LIST_SUCCESS';
export const GET_SUBSCRIPTION_PAYMENT_LIST_FAILURE = 'GET_SUBSCRIPTION_PAYMENT_LIST_FAILURE';


// CREATE PAYMENT
export const CREATE_PAYMENT_BEGIN = 'CREATE_PAYMENT_BEGIN';
export const CREATE_PAYMENT_SUCCESS = 'CREATE_PAYMENT_SUCCESS';
export const CREATE_PAYMENT_FAILURE = 'CREATE_PAYMENT_FAILURE';

// CHECK PAYMENT
export const CHECK_PAYMENT_BEGIN = 'CREATE_PAYMENT_BEGIN';
export const CHECK_PAYMENT_SUCCESS = 'CHECK_PAYMENT_SUCCESS';
export const CHECK_PAYMENT_FAILURE = 'CHECK_PAYMENT_FAILURE';
export const RESET_PAYMENT_ID = 'RESET_PAYMENT_ID';

// ADDRESS SEARCH
export const ADDRESS_SEARCH_BEGIN = 'ADDRESS_SEARCH_BEGIN';
export const ADDRESS_SEARCH_SUCCESS = 'ADDRESS_SEARCH_SUCCESS';
export const ADDRESS_SEARCH_FAILURE = 'ADDRESS_SEARCH_FAILURE';

// GET DEALER MONTH REPORT LIST
export const GET_DAILY_REPORT_LIST_BEGIN = 'GET_DAILY_REPORT_LIST_BEGIN';
export const GET_DAILY_REPORT_LIST_SUCCESS = 'GET_DAILY_REPORT_LIST_SUCCESS';
export const GET_DAILY_REPORT_LIST_FAILURE = 'GET_DAILY_REPORT_LIST_FAILURE';

// GET DAILY REPORT LIST
export const GET_DEALER_MONTH_REPORT_LIST_BEGIN = 'GET_DEALER_MONTH_REPORT_LIST_BEGIN';
export const GET_DEALER_MONTH_REPORT_LIST_SUCCESS = 'GET_DEALER_MONTH_REPORT_LIST_SUCCESS';
export const GET_DEALER_MONTH_REPORT_LIST_FAILURE = 'GET_DEALER_MONTH_REPORT_LIST_FAILURE';

// GET TICKET LIST
export const GET_TICKET_LIST_BEGIN = 'GET_TICKET_LIST_BEGIN';
export const GET_TICKET_LIST_SUCCESS = 'GET_TICKET_LIST_SUCCESS';
export const GET_TICKET_LIST_FAILURE = 'GET_TICKET_LIST_FAILURE';

// CREATE TICKET
export const CREATE_TICKET_BEGIN = 'CREATE_TICKET_BEGIN';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const CREATE_TICKET_FAILURE = 'CREATE_TICKET_FAILURE';

// UPDATE TICKET
export const UPDATE_TICKET_BEGIN = 'UPDATE_TICKET_BEGIN';
export const UPDATE_TICKET_SUCCESS = 'UPDATE_TICKET_SUCCESS';
export const UPDATE_TICKET_FAILURE = 'UPDATE_TICKET_FAILURE';

// DELETE TICKET
export const DELETE_TICKET_BEGIN = 'DELETE_TICKET_BEGIN';
export const DELETE_TICKET_SUCCESS = 'DELETE_TICKET_SUCCESS';
export const DELETE_TICKET_FAILURE = 'DELETE_TICKET_FAILURE';
